import { render, staticRenderFns } from "./SaldonTilaus-kiitos.vue?vue&type=template&id=38f419cd&"
import script from "./SaldonTilaus-kiitos.vue?vue&type=script&lang=js&"
export * from "./SaldonTilaus-kiitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports